module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasDuration()) ? _c('div', {
    staticClass: "countdown"
  }, [(_vm.hasDuration('years')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.years))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('years')) ? _c('span', [_vm._v("Jahre")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('months')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.months))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('months')) ? _c('span', [_vm._v("Monate")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('days')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.days))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('days')) ? _c('span', [_vm._v("Tage")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('hours')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hours))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('hours')) ? _c('span', [_vm._v("Stunden")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('minutes')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.minutes))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('minutes')) ? _c('span', [_vm._v("Minuten")]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('seconds')) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.seconds))]) : _vm._e(), _vm._v(" "), (_vm.hasDuration('seconds')) ? _c('span', [_vm._v("Sekunden")]) : _vm._e()]) : _c('div', {
    staticClass: "expired"
  }, [_c('span', [_vm._v("Der Countdown zum")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateReadable))]), _vm._v(" "), _c('span', [_vm._v("ist abgelaufen.")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.splitDateTime))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b72aa00","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = 151
// module chunks = 1